export default __webpack_public_path__ + "static/media/hungary.2fdaea82.png";